import styled from 'styled-components';

export const HeaderSection = styled.header`
  padding: 1.5rem 0;
  position: relative;
  z-index: 9;
  background: #EDF2F7;

  @media (max-width: 50rem) {
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  ${props => props.sticky && `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    transition: 150ms;
    transition-timing-function: ease-in-out;
    background: #fff;
    z-index: 9;
    padding: 1rem 0 !important;
    box-shadow: 0 16px 32px -5px rgba(50,50,93, .05), 0 8px 16px -8px rgba(0,0,0,.05);

    @media(max-width: 50rem) {
      nav {
        a {
          margin: 0;

          &.hm {
            display: none;
          }
        }
      }
    }
  `}
`;

export const Logo = styled.span`
  display: inline-block;

  img {
    display: block;
  }
`;

export const Menu = styled.nav`
  display: flex;
  align-items: center;

  > a {
    display: inline-block;
    margin-left: .5rem;
    color: #718096;
    line-height: 1.5;
    font-size: .70rem;
    text-align: center;
    font-weight: 400;

    @media (min-width: 50rem) {
      font-size: 1rem;
      margin-left: 1rem;
    }

    @media (max-width: 50rem) {
      display: none;
    }

    &:hover {
      color: #0070E0;
    }
  }
`;

export const MobileMenu = styled.nav`
  position: absolute;
  top: 6rem;
  left: 0;
  right: 0;
  width :100%;
  padding: 1rem 0;
  background: white;
  box-shadow: 0 16px 26px -5px rgba(50,50,93,.2);
  border-top: 1px solid #E7E8F0;

  .sticky-header & {
    top: 100%;
  }


  > a {
    display: block !important;
    color: #718096;
    width: 100%;
    letter-spacing: .03rem;
    padding: .5rem 1.5rem;
    font-weight: 400;
    line-height: 1.6;

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
      transition: all .15s;
      width: 100%;
    }
  }
`;

export const ButtonCTA = styled.a`
  color: #fff !important;
  padding: .5rem 1rem;
  line-height: 1 !important;
  transition: 150ms;
  transition-timing-function: ease-in-out;
  display: block !important;
  font-weight: 500 !important;
  background: #0070E0;
  font-size: 1.1rem !important;
  padding: .8rem 1rem;
  background: linear-gradient(96.06deg, #E53E3E 0.73%, #F56565 99.49%);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 50px;

  &:hover {
    color :#fff !important;
    background: linear-gradient(96.06deg, #E53E3E 0.73%, #F56565 99.49%);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  }

  @media(max-width: 26rem) {
    max-width: 200px;
    text-align: center;
    line-height: 1.2 !important;
    padding: .5rem .6rem;
    font-size: 1rem !important;
  }
`;

const ExtendButtonMenuStyle = `
  content: "";
  position: absolute;
  left: 0;
  width: 32px;
  height: 5px;
  border-radius: 15px;
  background-color: #718096;
  border: 0;
  outline: none;
  transition: all .25s;
`;

export const ButtonMenu = styled.button`
  ${ExtendButtonMenuStyle}
  position: relative;
  z-index: 10;
  margin-left: .5rem;

  @media (min-width: 50rem) {
    display: none;
  }

  &:before {
    ${ExtendButtonMenuStyle}
    top: -8px;
  }

  &:after {
    ${ExtendButtonMenuStyle}
    top: 8px;
  }

  ${props => props.isMenuOpen && `
    background-color: transparent;
    transition: all .25s;

    &:before {
      transition: all .25s;
      top: -0px;
      transform: rotate(45deg);
    }

    &:after {
      transition: all .25s;
      top: -0px;
      transform: rotate(-45deg);
    }
  `}
`
